export default __webpack_public_path__ + "locales/ja-JP/Ldap.json?hash=272068ac46885ed0cbf6a5bfb0bd8d76";